import { useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_COST_PRICING } from "@/seoContentV3";

let cached = null;
let inflight = null;

export default function usePricing() {
  const [pricing, setPricing] = useState(cached || DEFAULT_COST_PRICING);
  useEffect(() => {
    if (cached) return;
    inflight = inflight || axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/pricing`)
      .then(({ data }) => { if (data?.tiers?.length) cached = { ...DEFAULT_COST_PRICING, ...data }; return cached; })
      .catch(() => { inflight = null; return null; });
    inflight.then((p) => p && setPricing(p));
  }, []);
  return pricing;
}
